module.exports = __webpack_public_path__ + "img/Group 1200.cc20d3f5.png";